// (function () {
//   var imageMap = null;

//   function getImageMap() {
//     if (imageMap) return imageMap;
//     var el = document.getElementById("rapi-bundle-images-data");
//     if (!el) return null;
//     try { imageMap = JSON.parse(el.textContent || el.innerText); } catch (e) { return null; }
//     return imageMap;
//   }

//   function updateBarImage(bar, flavor) {
//     var map = getImageMap();
//     if (!map) return;
//     var titleEl = bar.querySelector(".rapi-bundles__bar-title");
//     if (!titleEl) return;
//     var bundleImages = map[titleEl.textContent.trim()];
//     if (!bundleImages) return;
//     var customImg = bar.querySelector(".rapi-bundle-custom-img");
//     if (!customImg) return;
//     var src = bundleImages[flavor] || bundleImages[Object.keys(bundleImages)[0]];
//     if (src && customImg.src !== src) customImg.src = src;
//   }

//   function getFirstFlavorSelect(bar) {
//     var allSelects = bar.querySelectorAll(".rapi-bundles__bar-variant-select");
//     for (var i = 0; i < allSelects.length; i++) {
//       var val = allSelects[i].value;
//       if (isNaN(val) || val === "") return allSelects[i];
//     }
//     return null;
//   }

//   function setupBars() {
//     var map = getImageMap();
//     if (!map) return;

//     document.querySelectorAll(".rapi-bundles__bar").forEach(function (bar) {
//       var titleEl = bar.querySelector(".rapi-bundles__bar-title");
//       if (!titleEl) return;
//       var bundleImages = map[titleEl.textContent.trim()];
//       if (!bundleImages) return;

//       var imgWrapper = bar.querySelector(".offer-image-preview");
//       if (!imgWrapper) return;

//       var originalImg = imgWrapper.querySelector("img:not(.rapi-bundle-custom-img)");
//       if (originalImg) originalImg.classList.add("rapi-bundle-metaimg-hidden");

//       var customImg = imgWrapper.querySelector(".rapi-bundle-custom-img");
//       if (!customImg) {
//         customImg = document.createElement("img");
//         customImg.className = "rapi-bundle-custom-img";
//         imgWrapper.appendChild(customImg);

//         // Init image: pehle active vario-variant se, phir #1 select se
//         var activeEl = document.querySelector("li.vario-variant.sv_active");
//         var initFlavor = activeEl ? activeEl.getAttribute("data-value") : null;

//         if (!initFlavor) {
//           var firstSel = getFirstFlavorSelect(bar);
//           initFlavor = firstSel
//             ? firstSel.options[firstSel.selectedIndex].text
//             : Object.keys(bundleImages)[0];
//         }

//         var src = bundleImages[initFlavor] || bundleImages[Object.keys(bundleImages)[0]];
//         if (src) customImg.src = src;
//       }

//       // ✅ Sirf #1 flavor select pe listener
//       var firstFlavorSelect = getFirstFlavorSelect(bar);
//       if (firstFlavorSelect && !firstFlavorSelect._rapiDone) {
//         firstFlavorSelect._rapiDone = true;
//         firstFlavorSelect.addEventListener("change", function () {
//           var text = this.options[this.selectedIndex]
//             ? this.options[this.selectedIndex].text
//             : null;
//           if (text) updateBarImage(bar, text);
//         });
//       }
//     });

//     // ✅ Vario variants: SAB bars update karo (koi condition nahi)
//     var variantsList = document.querySelector(".vario-variants");
//     if (variantsList && !variantsList._rapiDone) {
//       variantsList._rapiDone = true;
//       variantsList.addEventListener("click", function (e) {
//         var li = e.target.closest("li.vario-variant");
//         if (!li) return;
//         var flavor = li.getAttribute("data-value");
//         document.querySelectorAll(".rapi-bundles__bar").forEach(function (bar) {
//           updateBarImage(bar, flavor);
//         });
//       });
//     }
//   }

//   var mutationTimer = null;
//   new MutationObserver(function (mutations) {
//     var hasNewBars = mutations.some(function (m) {
//       return Array.from(m.addedNodes).some(function (n) {
//         return n.nodeType === 1 && (
//           n.classList && n.classList.contains("rapi-bundles__bar") ||
//           n.querySelector && n.querySelector(".rapi-bundles__bar")
//         );
//       });
//     });
//     if (!hasNewBars) return;
//     clearTimeout(mutationTimer);
//     mutationTimer = setTimeout(setupBars, 200);
//   }).observe(document.body, { childList: true, subtree: true });

//   document.addEventListener("click", function (e) {
//     var btn = e.target.closest(".rapi-subscription-simpleButton > div");
//     if (!btn) return;
//     setTimeout(function () {
//       document.querySelectorAll(".rapi-bundles__bar-variant-select").forEach(function (s) {
//         s._rapiDone = false;
//       });
//       var vario = document.querySelector(".vario-variants");
//       if (vario) vario._rapiDone = false;
//       setupBars();
//     }, 300);
//   });

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", setupBars);
//   } else {
//     setupBars();
//   }
// })();

/* =========================
   FLAVOR SWATCH → BORDER COLOR
========================= */

// (function() {
//   var flavorColors = {
//     "Berry Rush":    "#e8194b",
//     "Green Blitz":   "#28a745",
//     "Melon Mania":   "#ff6b6b",
//     "Electric Blue": "#007bff",
//     "Mango Surge":   "#ff9f1c",
//     "Citrus\u00a0Surge": "#f7c948",
//     "Berry Blitz":   "#c0392b",
//     "Orange Surge":  "#fd7f20",
//   };

//   function applyBorderColor(flavor) {
//     var color = flavorColors[flavor];
//     if (!color) return;

//     // document.querySelectorAll(".rapi-bundles__bar label").forEach(function(label) {
//     //   label.style.cssText += "box-shadow: " + color + " 0px 0px 0px 2px inset !important;";
//     // });


//     var mainContainer = document.querySelector(".main-container");
//     if (mainContainer) {
//       mainContainer.style.cssText += "border: 2px solid " + color + " !important; box-shadow: 0 0 0 4px " + color + "33, 0 4px 24px " + color + "44 !important;";
//     }
//   }

//   function startFlavorListener() {
//     var variantsList = document.querySelector(".vario-variants");
//     if (!variantsList) {
//       setTimeout(startFlavorListener, 500);
//       return;
//     }

//     // Page load pe active flavor apply karo
//     var activeEl = document.querySelector("li.vario-variant.sv_active");
//     if (activeEl) applyBorderColor(activeEl.getAttribute("data-value").trim());

//     // Click pe apply karo
//     variantsList.addEventListener("click", function(e) {
//       var li = e.target.closest("li.vario-variant");
//       if (!li) return;
//       var flavor = li.getAttribute("data-value");
//       if (flavor) applyBorderColor(flavor.trim());
//     });
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startFlavorListener);
//   } else {
//     startFlavorListener();
//   }
// })();

/* =========================
   ADD LIMITED BADGES
========================= */
function addLimitedBadges() {

  const limitedFlavours = [
    "Mango Surge",
    "Orange Surge",
    "Green Blitz",
    
  ];

  document.querySelectorAll(".vario-variant").forEach((item) => {

    const nameEl = item.querySelector(".vsna span");
    if (!nameEl) return;

    const flavourName = nameEl.innerText.trim();

    if (limitedFlavours.includes(flavourName)) {

      if (!item.querySelector(".vario-badge")) {
        const badge = document.createElement("span");
        badge.className = "vario-badge";
        badge.innerText = "Limited Edition";

        item.appendChild(badge);
      }
    }
  });
}

addLimitedBadges();

new MutationObserver(addLimitedBadges).observe(document.body, {
  childList: true,
  subtree: true
});





/* =========================
   FRONTROW BANNER PERSISTENCE
========================= */
(function() {
  var productMap = {
    '/products/nutrify-daily-green-bites-120-count':                  '5306',
    '/products/mushroom-daily-focus':                             '5032',
    '/products/nutrify-daily-green-bites-for-kids-120-counts-copy':   '5031',
    'products/nutrify-daily-green-bites-for-kids-120-count': '5031',
    '/products/nutrify-daily-creatine-bites-60-count':                 '4715',
    '/products/mushroom-daily-focus': '5032'
  };

  var path = window.location.pathname;
  var productId = null;

  for (var slug in productMap) {
    if (path.includes(slug)) {
      productId = productMap[slug];
      break;
    }
  }

  if (!productId) return;


function ensureFrontrowBanner() {
  var firstSlide = document.querySelector('.swiper-slide');
  if (!firstSlide) return;
  if (document.getElementById('frontrow-sticker')) return;

  // Load the widget's companion script (enables the interactive/expand behavior)
  if (!document.getElementById('frontrow-sticker-script')) {
    var scriptSrcSticker = 'https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=sticker&product_id=' + productId;
    var scriptSticker = document.createElement('script');
    scriptSticker.async = true;
    scriptSticker.src = scriptSrcSticker;
    document.head.appendChild(scriptSticker);
  }

  var iframe = document.createElement('iframe');
  iframe.id = 'frontrow-sticker';
  iframe.className = 'iframe-frontrow-sticker';
  iframe.setAttribute('data-state', 'max');
  iframe.setAttribute('frameborder', '0');
  iframe.src = 'https://app.thefrontrowhealth.com/api/widgets?presentation_type=sticker&product_id=' + productId;

  iframe.style.cssText = 'position:absolute;z-index:3;border-radius:0;top:0;left:0;';
  firstSlide.style.position = 'relative';
  firstSlide.appendChild(iframe);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureFrontrowBanner);
  } else {
    ensureFrontrowBanner();
  }

  var observer = new MutationObserver(function() {
    if (!document.getElementById('frontrow-sticker')) ensureFrontrowBanner();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();